export default class Company {
    constructor() {
        this.id;
        this.representativeId;
        this.subscriptionId;
        this.name;
        this.code;

    }

    set(setEntity) {
        this.id = setEntity.id;
        this.representativeId = setEntity.representativeId;
        this.subscriptionId = setEntity.subscriptionId;
        this.name = setEntity.name;
        this.code = setEntity.code;
        return this;
    }
}
